<div class="page-content-wrap contentdata">
  <div class="row">
    <div class="col-md-12">
      <!-- breadcrumb -->
      <div class="row">
        <div class="col-md-12">
          <div class="page-breadcrumb">
           <ul class="page-breadcrumb__trail">
              <li><a>Metrics</a></li>
              <li><a>Farm</a></li>
              <li><a>Water Quality Readings History</a></li>
            </ul>
          <div class="page-breadcrumb__icons">
              <a routerLink="/home" *ngIf="loginUserBusinessCategory != 'Provider'"><img src="../../../../assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>
              <a routerLink="/home/dashboard" *ngIf="loginUserBusinessCategory == 'Provider'"><img src="../../../../assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>
            </div>
          </div>
        </div>
      </div>
      <!-- breadcrumb End -->
      <!-- START FORM VALIDATION STATES -->
      <div class="block">
        <div class="screen_heading_div">
          <span>Water Quality</span>
        </div>
        <div class="Reports_form_div">
          <form class="form-horizontal" role="form" [formGroup]="registerForm" (clickOutside)="isDropdownOpen = false">
            <div class="reports-form-container">

              <!-- Business Selection Field -->
              <mat-form-field appearance="outline" class="w-100" *ngIf="loginPersonType == 'EMPLOYEE'">
                <mat-label>Business Name</mat-label>
                <!-- search box powered by mat‑autocomplete -->
                <input matInput type="text" id="businessname" autocomplete="off" formControlName="businessnameField"
                      placeholder="Search business" (keyup)="filterBusinesses()"
                      (click)="isDropdownOpen = true" (focus)="filteredOptions = businessEntities"
                      [matAutocomplete]="businessAuto"/>
                <mat-autocomplete #businessAuto="matAutocomplete" (optionSelected)="selectOption($event.option.value)">
                  <mat-option *ngFor="let option of filteredOptions" [value]="option">
                    {{ option.businessName }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
              
              <!-- Farm Site (Conditional) -->
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Farm</mat-label>
                <mat-select
                  [(ngModel)]="reading.farm_site_id"
                  formControlName="locationameField"
                  (selectionChange)="handleReadingsTable()"
                  (click)="isDropdownOpen = false"
                >
                  <mat-option value="">Select Farm</mat-option>
                  <mat-option *ngFor="let farmsite of farmSites" [value]="farmsite.id">
                    {{ farmsite.farmNameAtLocation + ' -- ' + (farmsite?.address?.village) }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Farm Site</mat-label>
                <mat-select
                  [(ngModel)]="reading.farm_site_id"
                  formControlName="locationameField"
                  (click)="isDropdownOpen = false"
                >
                  <mat-option value="">Select Farm Site</mat-option>
                  <mat-option *ngFor="let farmsite of farmSites" [value]="farmsite.id">
                    {{ farmsite.farmNameAtLocation + ' -- ' + (farmsite?.address?.village) }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <!-- ───────── DATE RANGE ───────── -->
              <mat-form-field appearance="outline" class="w-100" formGroupName="dateRangeField">
                  <mat-label>Date Range</mat-label>

                  <mat-date-range-input [rangePicker]="picker"
                                        [max]="maxDate" 
                                        (focus)="picker.open()"
                                        (click)="picker.open()">
                    <input matStartDate placeholder="Start date" formControlName="start" readonly />
                    <input matEndDate placeholder="End date" formControlName="end" readonly />
                  </mat-date-range-input>

                  <!-- Dynamic icon: calendar or clear (×) -->
                  <button mat-icon-button
                    matSuffix
                    [ngStyle]="{
                      'z-index': 1000,
                      'position': 'relative',
                      'background': 'none',
                      'border': 'none',
                      'box-shadow': 'none',
                      'outline': 'none'
                    }"
                    (click)="isDateRangeSelected ? clearDateRange() : picker.open()"
                    aria-label="Toggle date">

                    <!-- Show normal calendar icon if no filter applied -->
                    <mat-icon *ngIf="!isDateRangeSelected">calendar_today</mat-icon>

                    <!-- Show × if filter is applied -->
                    <span *ngIf="isDateRangeSelected"
                          style="font-size: 20px; font-weight: bold;color: red;padding-right: 1rem;">&times;</span>
                  </button>

                <mat-date-range-picker #picker (closed)="onPickerClosed()"></mat-date-range-picker>
              </mat-form-field>

              <!-- Is Preparatory -->
              <mat-form-field *ngIf="(loginPersonType != 'Farmer' && loginPersonType != 'Farm Manager' && loginPersonType != 'Business Admin') && loginUserBusinessCategory != 'Farm'" appearance="outline" class="w-100">
                <mat-label>Is Preparatory</mat-label>
                <mat-select
                  [(ngModel)]="reading.isPreparatory"
                  formControlName="prepdaratory"
                  id="prep"
                >
                  <mat-option value="">Select Preparatory</mat-option>
                  <mat-option value="1">IsPreparatory</mat-option>
                  <mat-option value="0">Culture</mat-option>
                </mat-select>
              </mat-form-field>

              <!-- Test Type -->
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Test Type</mat-label>
                <mat-select
                  [(ngModel)]="reading.testType"
                  (selectionChange)="aqucmdate()"
                  formControlName="testtype"
                  id="testtype"
                >
                  <mat-option value="">Select Type</mat-option>
                  <mat-option value="0">AQU</mat-option>
                  <mat-option value="1">AQU-CM</mat-option>
                </mat-select>
              </mat-form-field>

            </div>
          </form>
          <div class="form-field">
            <div class="buttons-div reports_search_div">
              <div class="transactions-button-container" (click)="getReatdings()">
                <button class="transaction-submit-button">
                  <span class="icon"><img src="../../../../../../assets/images/New_Icons/search-icon.svg"></span>
                  <span class="text">Search</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="!responseLoader">
          <div class="adjust loader-container">
            <div class="loader2"></div>
          </div>
        </div>
        <div class="reports_block" *ngIf="isSearchClicked">
          <div class="search_cum_icons_button_container">
            <div class="gap"></div>
            <div class="add-button-container">
              <img src="../../../../../assets/images/New_Icons/excel-download-icon.svg" (click)="exportExcel()">
            </div>
          </div>
          <div class="table-responsive">
            <div class="row" [hidden]="!(inputData.testType == 1)">
              <span class="fa fa-refresh refereshstyle" (click)="refereshFunction()"></span>
            </div>
            <table class="table table-striped table-bordered table-hover">
              <thead>
              <tr>
                <th class="handSymbol" (click)="sortingHistory('date')">Date(Time)
                  <span class="glyphicon sort-icon"
                        [ngClass]="{'glyphicon-chevron-up':dateAsc,'glyphicon-chevron-down':!dateAsc}"></span>
                </th>
                <th class="handSymbol" (click)="sortingHistory('farmname')">Farm Name
                  <span class="glyphicon sort-icon"
                        [ngClass]="{'glyphicon-chevron-up':farmnameAsc,'glyphicon-chevron-down':!farmnameAsc}"></span>
                </th>
                <th class="handSymbol" (click)="sortingHistory('sectionname')">Section Name
                  <span class="glyphicon sort-icon"
                        [ngClass]="{'glyphicon-chevron-up':sectionnameAsc,'glyphicon-chevron-down':!sectionnameAsc}"></span>
                </th>
                <th class="handSymbol" (click)="sortingHistory('pondname')">Pond Name
                  <span class="glyphicon sort-icon"
                        [ngClass]="{'glyphicon-chevron-up':pondnameAsc,'glyphicon-chevron-down':!pondnameAsc}"></span>
                </th>
                <th class="handSymbol" (click)="sortingHistory('serialnumber')">Serial Number
                  <span class="glyphicon sort-icon"
                        [ngClass]="{'glyphicon-chevron-up':serialnumberAsc,'glyphicon-chevron-down':!serialnumberAsc}"></span>
                </th>
                <th *ngIf="readingsCondtions.time_interval && reading.isPreparatory == 1">Time Interval</th>
                <th *ngIf="readingsCondtions.pH">pH</th>
                <th *ngIf="readingsCondtions.salinity">Salinity</th>
                <th *ngIf="readingsCondtions.do2">DO</th>
                <th *ngIf="readingsCondtions.turbidity">Turbidity</th>
                <th *ngIf="readingsCondtions.conductivity">Conductivity</th>
                <th *ngIf="readingsCondtions.tds">TDS</th>
                <th *ngIf="readingsCondtions.temperature">Temperature</th>
                <th *ngIf="readingsCondtions.sg">Specific Gravity</th>
                <th>Magnesium</th>
                <th>Carbonate</th>
                <th>Bi Carbonate</th>
                <th *ngIf="readingsCondtions.tan">TAN</th>
                <th>Calcium</th>
                <th *ngIf="readingsCondtions.alkalinity">Alkalinity</th>
                <th>Hardness</th>
                <th *ngIf="readingsCondtions.orp">ORP(mV)</th>
                <th *ngIf="readingsCondtions.uam">U.Ammonia(ppm)</th>
                <th>Biofloc(Mg/Ltr)</th>
                <th>Ammonia</th>
                <th *ngIf="readingsCondtions.nitrite">Nitrite</th>
                <th *ngIf="readingsCondtions.comment">Comment</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let readings of resultantReadings; let i = index">
                <td>{{readings.time}}</td>
                <td>{{readings.farm_name}}</td>
                <td>{{readings && readings.pond && readings.pond.PondSection && readings.pond.PondSection.section_name}}</td>
                <td>{{readings && readings.pond && readings.pond.name}}</td>
                <td>{{readings && readings.device && readings.device.serial_number}}</td>
                <td
                  *ngIf="readingsCondtions.time_interval && reading.isPreparatory == 1">{{readings && readings.time_interval}}</td>
                <td *ngIf="readingsCondtions.pH">{{readings && readings.pH}}</td>
                <td *ngIf="readingsCondtions.salinity">{{readings && readings.salinity}}</td>
                <td *ngIf="readingsCondtions.do2">{{readings.do2}}</td>
                <td *ngIf="readingsCondtions.turbidity">{{readings.turbidity}}</td>
                <td *ngIf="readingsCondtions.conductivity">{{readings.conductivity}}</td>
                <td *ngIf="readingsCondtions.tds">{{readings.tds}}</td>
                <td *ngIf="readingsCondtions.temperature">{{readings.temperature}}</td>
                <td *ngIf="readingsCondtions.sg">{{readings.sg}}</td>
                <td>{{readings.Magnesium}}</td>
                <td>{{readings.Carbonate}}</td>
                <td>{{readings.BiCarbonate}}</td>
                <td *ngIf="readingsCondtions.tan">{{readings.tan}}</td>
                <td>{{readings.Calcium}}</td>
                <td *ngIf="readingsCondtions.alkalinity">{{readings.alkalinity}}</td>
                <td>{{readings.Hardness}}</td>
                <td *ngIf="readingsCondtions.orp">{{readings.orp}}</td>
                <td *ngIf="readingsCondtions.uam">{{readings.uam}}</td>
                <td>{{readings.Bio_Floc}}</td>
                <th>{{readings.T_Ammonia}}</th>
                <td *ngIf="readingsCondtions.nitrite">{{readings.nitrite}}</td>
                <td
                  *ngIf="readingsCondtions.comment">{{(readings.comment == "" || readings.comment == null) ? 'NA' : readings.comment}}</td>
              </tr>
              </tbody>
            </table>
            <!--<div class="pull-right pagination_div">
              <pagination-controls (pageChange)="currentpagenum = $event"></pagination-controls>
            </div>-->
            <div *ngIf="listLoader" class="loader-div">
              <div class="adjust">
                <div class="loader2 list-loader"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END FORM VALIDATION STATES -->
    </div>
  </div>
  <!-- END PAGE CONTENT WRAPPER -->
</div>
